// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3hRUO","list":"PatternAutocomplete_list__6hrL7"};